import { useRef } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { NotesTextEditor, NotesTextEditorSkeleton } from '@factorialco/f0-react/dist/experimental'
import { PagesUploadFilePreviewDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { useNotesTextEditor } from 'modules/pages/lib/hooks/useNotesTextEditor'
import { usePageAutosave } from 'modules/pages/lib/hooks/usePageAutosave'

interface PagePreviewProps {
  pageId: number
  containerHeight?: number
}

export const PagePreview = ({ pageId, containerHeight }: PagePreviewProps) => {
  const { toolbarLabels, titlePlaceholder, placeholder } = useNotesTextEditor()
  const { debouncedAutosave } = usePageAutosave({ pageId })
  const contentRef = useRef<string>('')
  const titleRef = useRef<string>('')

  const { data: pageData, loading: loadingPage } = useQuery(PagesUploadFilePreviewDocument, {
    variables: {
      id: pageId,
    },
    skip: !pageId,
  })

  const currentPage = pageData?.handbookPages?.page

  // Update refs when page data loads
  if (currentPage) {
    contentRef.current = currentPage.content ?? ''
    titleRef.current = currentPage.title ?? ''
  }

  const editorConfig = {
    labels: { toolbarLabels, titlePlaceholder },
    placeholder,
    initialEditorState: {
      content:
        currentPage && currentPage.content && currentPage.content.trim() !== ''
          ? JSON.parse(currentPage.content)
          : undefined,
      title: currentPage?.title,
    },
  }

  return (
    <Box
      width="full"
      flexGrow
      overflowY="hidden"
      border={{
        right: {
          width: 's1',
          style: 'solid',
          color: 'grey300',
        },
        left: {
          width: 's1',
          style: 'solid',
          color: 'grey300',
        },
      }}
      style={{
        // TODO: this is a hack because the content is inside an scrollarea and is not possible to set the height to the container height
        height: containerHeight ? `${containerHeight}px` : undefined,
      }}
    >
      {loadingPage ? (
        <NotesTextEditorSkeleton withPadding withHeader={false} withTitle withToolbar={false} />
      ) : (
        <NotesTextEditor
          key={pageId}
          {...editorConfig}
          onChange={({ json }) => {
            const jsonString = JSON.stringify(json)
            contentRef.current = jsonString
            debouncedAutosave(jsonString, titleRef.current)
          }}
          onTitleChange={(title) => {
            if (title !== titleRef.current && title.trim() !== '') {
              titleRef.current = title
              debouncedAutosave(contentRef.current, title)
            }
          }}
        />
      )}
    </Box>
  )
}
